import { apiFetchJson, apiGet, apiPost } from './apiClient';

export interface PresentationRequest {
  id: string;
  data_package_id: string;
  user_id: string;
  status: 'pending' | 'sent' | 'contacted' | 'closed';
  created_at: string;
  updated_at: string;
}

export const checkPresentationRequest = async (dataPackageId: string): Promise<boolean> => {
  try {
    const payload = await apiGet<{ exists: boolean }>(
      `/presentations/requests/${encodeURIComponent(dataPackageId)}/check`,
    );
    return Boolean(payload?.exists);
  } catch (error) {
    console.error('Error in checkPresentationRequest:', error);
    return false;
  }
};

export async function requestPresentationAccess(params: {
  packageName: string;
  phone: string;
  dataPackageId?: string;
  context?: string;
}): Promise<{ ok: boolean; error?: string }> {
  const result = await apiFetchJson<{ success: boolean }>('POST', '/presentations/request-access', {
    body: params,
  });
  if (!result.ok) {
    return { ok: false, error: result.error };
  }
  return { ok: Boolean(result.data?.success) };
}

export const createPresentationRequest = async (
  dataPackageId: string,
  packageName?: string,
  phone?: string,
): Promise<boolean> => {
  try {
    const alreadyRequested = await checkPresentationRequest(dataPackageId);
    if (alreadyRequested) {
      return true;
    }

    const payload = await apiPost<{ success: boolean }>('/presentations/requests', {
      dataPackageId,
      packageName,
      phone,
    });
    return Boolean(payload?.success);
  } catch (error) {
    console.error('Error in createPresentationRequest:', error);
    return false;
  }
};
